<template>
	<div class="ui centered  padded grid">
    <nav-details-top></nav-details-top>

    <div class="sixteen wide column">
      <h2 v-if="$route.name === 'PageLessonPlanCreate'"class=" ui big header">Create New Lesson</h2>
      <h2 v-else class="ui big header">Edit Lesson</h2>
      <div class="ui divider"></div>
    </div>

    <lesson-plan-create-edit :inheritedLesson="inheritedLesson"
                             :inheritedLessonId="inheritedLessonId"></lesson-plan-create-edit>
	</div>
</template>

<script>
  // TODO: This is the creation page for Lesson Plan Blocks

  import NavDetailsTop from "../NavDetailsTop"
  import LessonPlanCreateEdit from './LessonPlanCreateEdit.vue'
  import { mapGetters, mapState } from 'vuex'

  export default {
    props: {
      lesson: {
        type: Object,
        default: function() {
          return {}
        }
      },
      id: {
        type: Number,
        default: function() {
          return Number(this.$route.params.lessonid);
        }
      }
    },
		data() {
      let id = isNaN(this.id) ?  null : this.id;

			return {
        inheritedLessonId: id == null ?  null : id,
        inheritedLesson: id == null ? {} : this.lesson
      }
		},
    components: {
      NavDetailsTop,
      LessonPlanCreateEdit
    },
		computed: {
      ...mapState(['coachingLessonsAll']),
    },
		methods: {
      getLessonById() {
        return this.coachingLessonsAll.find((lesson) => lesson.id === this.inheritedLessonId);
      }
    },
    created() {
      if (!(isNaN(this.id))) {
        this.inheritedLesson = this.getLessonById();
      }
    },
		mounted() {

    },
    updated() {

    }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/content/PageLessonPlanCreate.vue